module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm-dfb19d91645db1db53324538f45cd6bf.webp";